import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from 'packages/client/src/app/components/kit/base-dialog/base-dialog.component';
import { CheckInputComponent } from 'packages/client/src/app/components/kit/input/check-input/check-input.component';
import { NumberInputComponent } from 'packages/client/src/app/components/kit/input/text-input/number-input.component';
import { fb } from 'packages/client/src/app/modules/shared/shared.global-service';
import { FolderWarehouseMaterialOperationDialogStore } from '../warehouse-material-operation-dialog/warehouse-material-operation-dialog.store';
import { WarehouseMaterialOperationTypeEnum } from '@libs/types/src/services/enum/warehouse-material-operation.enum';
import { contentGlobalSuccess } from 'packages/client/src/app/modules/content/content.error';
import { getWarehouseMaterialsFrag } from '../warehouse-material.query';

@Component({
    selector: 'app-warehouse-material-replenish-dialog',
    templateUrl: 'warehouse-material-replenish-dialog.component.html',
    providers: [FolderWarehouseMaterialOperationDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CheckInputComponent,
        NumberInputComponent,
    ],
})
export class WarehouseMaterialReplenishDialogComponent extends BaseDialogComponent {

    protected readonly store = inject(FolderWarehouseMaterialOperationDialogStore);
    protected readonly prefix = 'service.warehouseMaterialOperation.';

    protected form = fb.group({
        replenishMissing: fb.control<boolean>(true),
        amount: fb.control<number>(this.dialogConfig.data.missingAmount || 1),
    });

    override save(_event: Event): void {
        const amount = this.form.controls.replenishMissing.value ? 5 : this.form.controls.amount.value || 0;
        if (amount <= 0) return;

        const data = this.dialogConfig.data;

        this.store.api.createWarehouseMaterialOperation({
            warehouseMaterialId: data.warehouseMaterialId,
            type: WarehouseMaterialOperationTypeEnum.RECEIPT,
            amount,
            date: data.date,
            description: data.description,
            folderId: null,
            workId: null,
            workerIds: data.workerIds,
        }, getWarehouseMaterialsFrag).then((res) => {
            if (!res) return;

            contentGlobalSuccess.next('common.created');
            this.dialogRef.close({ refresh: true, retryOriginal: true });
        });
    }
}
